(function() {
  'use strict';

  var SUPABASE_URL = 'https://tbzlhewcevuyopsytcwi.supabase.co';
  var SUPABASE_ANON_KEY = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InRiemxoZXdjZXZ1eW9wc3l0Y3dpIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NzkzMTA3MzIsImV4cCI6MjA5NDg4NjczMn0.AgZa1dXiowhgqMlCOSN9EuUpYOkDCitCmvUxsk3C6OA';

  var CHAT_MEDIA_BUCKET = 'chat-media';
  var CHAT_MEDIA_MAX_BYTES = 5 * 1024 * 1024;
  var CHAT_MEDIA_ALLOWED_TYPES = {
    'image/jpeg': 'jpg',
    'image/png': 'png',
    'image/webp': 'webp',
    'image/gif': 'gif'
  };

  function isAllowedChatMediaUrl(url) {
    if (!url || typeof url !== 'string') return false;
    try {
      var parsed = new URL(url, window.location.origin);
      if (parsed.protocol !== 'https:') return false;
      var host = parsed.hostname.toLowerCase();
      if (host === 'tbzlhewcevuyopsytcwi.supabase.co') {
        return parsed.pathname.indexOf('/storage/v1/object/') === 0;
      }
      // Common GIF providers used by attach flows
      if (host === 'media.giphy.com' || host === 'i.giphy.com' || host === 'media0.giphy.com' ||
          host === 'media1.giphy.com' || host === 'media2.giphy.com' || host === 'media3.giphy.com' ||
          host === 'media4.giphy.com' || host.endsWith('.giphy.com')) {
        return true;
      }
      if (host === 'media.tenor.com' || host.endsWith('.tenor.com')) return true;
      return false;
    } catch (e) {
      return false;
    }
  }

  function ensureChatLightbox() {
    var overlay = document.getElementById('gm-chat-lightbox');
    if (overlay) return overlay;

    overlay = document.createElement('div');
    overlay.id = 'gm-chat-lightbox';
    overlay.className = 'gm-chat-lightbox';
    overlay.hidden = true;
    overlay.innerHTML =
      '<button type="button" class="gm-chat-lightbox-close" aria-label="close image">&times;</button>' +
      '<img class="gm-chat-lightbox-img" alt="" />';

    overlay.addEventListener('click', function(e) {
      if (e.target === overlay || e.target.closest('.gm-chat-lightbox-close')) {
        closeChatLightbox();
      }
    });

    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape') closeChatLightbox();
    });

    document.body.appendChild(overlay);
    return overlay;
  }

  function openChatLightbox(src, alt) {
    var overlay = ensureChatLightbox();
    var img = overlay.querySelector('.gm-chat-lightbox-img');
    if (img) {
      img.src = src;
      img.alt = alt || 'chat image';
    }
    overlay.hidden = false;
    document.body.classList.add('gm-chat-lightbox-open');
  }

  function closeChatLightbox() {
    var overlay = document.getElementById('gm-chat-lightbox');
    if (!overlay) return;
    overlay.hidden = true;
    var img = overlay.querySelector('.gm-chat-lightbox-img');
    if (img) img.removeAttribute('src');
    document.body.classList.remove('gm-chat-lightbox-open');
  }

  function escHtml(value) {
    return String(value || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function timeAgo(dateStr) {
    var diff = Math.floor((Date.now() - new Date(dateStr).getTime()) / 1000);
    if (diff < 60) return 'just now';
    if (diff < 3600) return Math.floor(diff / 60) + 'm ago';
    if (diff < 86400) return Math.floor(diff / 3600) + 'h ago';
    return Math.floor(diff / 86400) + 'd ago';
  }

  function getErrorText(data) {
    if (!data) return '';
    if (typeof data.message === 'string') return data.message;
    if (typeof data.error === 'string') return data.error;
    if (data.error && typeof data.error === 'object') return data.error.message || data.error.details || '';
    if (data.details) return String(data.details);
    return '';
  }

  function getAuthApi() {
    return window.__gmAuth || null;
  }

  function getCurrentUser() {
    var auth = getAuthApi();
    return auth && typeof auth.getCurrentUser === 'function' ? auth.getCurrentUser() : null;
  }

  async function getValidAccessToken() {
    var auth = getAuthApi();
    if (auth && typeof auth.getValidAccessToken === 'function') {
      return auth.getValidAccessToken();
    }
    return null;
  }

  function isMobileChatViewport() {
    return window.matchMedia('(max-width: 900px)').matches;
  }

  function GmChat(root) {
    this.root = root;
    this.style = root.getAttribute('data-style') || 'community';
    this.contextType = root.getAttribute('data-context-type') || 'coming_soon';
    this.contextId = root.getAttribute('data-context-id') || 'main';
    this.profileHref = root.getAttribute('data-profile-href') || '/pages/profile';
    this.prefix = 'gm-' + this.style + '-chat';

    this.feed = root.querySelector('.' + this.prefix + '-feed');
    this.messagesEl = root.querySelector('.' + this.prefix + '-messages');
    this.emptyEl = root.querySelector('.' + this.prefix + '-empty');
    this.composerEl = root.querySelector('[data-gm-chat-composer]');
    this.lockedEl = root.querySelector('[data-gm-chat-locked]');
    this.inputEl = root.querySelector('[data-gm-chat-input]');
    this.sendBtn = root.querySelector('[data-gm-chat-send]');
    this.attachBtn = root.querySelector('[data-gm-chat-attach]');
    this.mediaInput = root.querySelector('[data-gm-chat-media-input]');
    this.mediaPreview = root.querySelector('[data-gm-chat-media-preview]');
    this.mediaPreviewImg = root.querySelector('[data-gm-chat-media-preview-img]');
    this.mediaClearBtn = root.querySelector('[data-gm-chat-media-clear]');
    this.replyBanner = root.querySelector('[data-gm-chat-reply-banner]');
    this.replyBannerText = root.querySelector('[data-gm-chat-reply-banner-text]');
    this.replyCancelBtn = root.querySelector('[data-gm-chat-reply-cancel]');

    this.allComments = [];
    this.commentLikeCounts = {};
    this.commentUserLiked = {};
    this.pendingChatMedia = null;
    this.chatMediaUploading = false;
    this.replyingTo = null;
    this.didInitialRender = false;
    this.chatKeyboardOpen = false;
    this.keyboardListenersBound = false;

    this.bindEvents();
    this.syncAuthUi();
    this.loadComments();

    var self = this;
    window.addEventListener('gm-auth-change', function() {
      self.syncAuthUi();
      self.loadComments(true);
    });
  }

  GmChat.prototype.cls = function(part) {
    return this.prefix + '-' + part;
  };

  GmChat.prototype.bindEvents = function() {
    var self = this;

    if (this.sendBtn) {
      this.sendBtn.addEventListener('click', function() {
        self.sendBtn.blur();
        self.postComment();
      });
    }

    if (this.inputEl) {
      this.inputEl.addEventListener('keydown', function(e) {
        if (e.key === 'Enter') {
          e.preventDefault();
          self.postComment();
        }
      });
      this.inputEl.addEventListener('focus', function() {
        self.onComposerFocus();
      });
      this.inputEl.addEventListener('blur', function() {
        self.onComposerBlur();
      });
    }

    if (this.attachBtn && this.mediaInput) {
      this.attachBtn.addEventListener('click', function() {
        if (self.chatMediaUploading) return;
        self.mediaInput.click();
      });
      this.mediaInput.addEventListener('change', function(e) {
        self.handleChatMediaSelected(e);
      });
    }

    if (this.mediaClearBtn) {
      this.mediaClearBtn.addEventListener('click', function() {
        self.clearPendingChatMedia();
      });
    }

    if (this.replyCancelBtn) {
      this.replyCancelBtn.addEventListener('click', function() {
        self.clearReplyingTo();
      });
    }

    if (this.lockedEl) {
      this.lockedEl.addEventListener('click', function() {
        window.location.href = self.profileHref;
      });
      this.lockedEl.addEventListener('keydown', function(e) {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          window.location.href = self.profileHref;
        }
      });
    }
  };

  GmChat.prototype.syncAuthUi = function() {
    var user = getCurrentUser();
    var loggedIn = !!user;
    if (this.composerEl) this.composerEl.hidden = !loggedIn;
    if (this.lockedEl) this.lockedEl.hidden = loggedIn;
  };

  GmChat.prototype.isFeedNearBottom = function() {
    if (!this.feed) return true;
    var threshold = 48;
    return (this.feed.scrollHeight - this.feed.scrollTop - this.feed.clientHeight) <= threshold;
  };

  GmChat.prototype.scrollToBottom = function(aggressive) {
    if (!this.feed) return;
    var feed = this.feed;
    function snap() {
      feed.scrollTop = feed.scrollHeight;
    }
    snap();
    window.requestAnimationFrame(snap);
    if (aggressive) {
      window.setTimeout(snap, 50);
      window.setTimeout(snap, 200);
    }
  };

  GmChat.prototype.notifyRendered = function(options) {
    options = options || {};
    window.dispatchEvent(new CustomEvent('gm-chat-rendered', { detail: { root: this.root } }));
    if (options.scrollToBottom === false) return;
    var shouldScroll = options.forceScroll || !this.didInitialRender || this.isFeedNearBottom();
    if (!shouldScroll) return;
    var self = this;
    var aggressive = !!options.forceScroll || !this.didInitialRender;
    window.requestAnimationFrame(function() {
      self.scrollToBottom(aggressive);
    });
  };

  GmChat.prototype.getCommentByIdMap = function(comments) {
    var byId = {};
    (comments || []).forEach(function(c) {
      if (c && c.id) byId[c.id] = c;
    });
    return byId;
  };

  GmChat.prototype.getCommentDisplayName = function(comment) {
    if (comment.profiles && comment.profiles.username) return comment.profiles.username;
    var user = getCurrentUser();
    if (user && comment.user_id === user.id) {
      var meta = user.user_metadata || {};
      if (meta.username) return meta.username;
    }
    return 'anonymous';
  };

  GmChat.prototype.getHeartIconMarkup = function(liked) {
    var heartPath = 'M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54z';
    if (liked) {
      return '<svg class="gm-chat-like-svg" viewBox="0 0 24 24" aria-hidden="true"><path fill="currentColor" d="' + heartPath + '"/></svg>';
    }
    return '<svg class="gm-chat-like-svg" viewBox="0 0 24 24" aria-hidden="true"><path fill="none" stroke="currentColor" stroke-width="1.6" stroke-linejoin="round" d="' + heartPath + '"/></svg>';
  };

  GmChat.prototype.paintLikeButton = function(btn, commentId) {
    if (!btn) return;
    var count = this.commentLikeCounts[commentId] || 0;
    var liked = !!this.commentUserLiked[commentId];
    btn.classList.toggle('is-liked', liked);
    var icon = btn.querySelector('.gm-chat-like-icon');
    var countEl = btn.querySelector('.gm-chat-like-count');
    if (icon) icon.innerHTML = this.getHeartIconMarkup(liked);
    if (countEl) countEl.textContent = String(count);
  };

  GmChat.prototype.buildCommentBubble = function(comment) {
    var bubble = document.createElement('div');
    bubble.className = this.cls('bubble');
    if (comment.media_url && isAllowedChatMediaUrl(comment.media_url)) {
      var mediaUrl = comment.media_url;
      var img = document.createElement('img');
      img.className = 'gm-chat-media';
      img.src = mediaUrl;
      img.alt = comment.media_type === 'gif' ? 'gif' : 'photo';
      img.loading = 'lazy';
      img.referrerPolicy = 'no-referrer';
      img.tabIndex = 0;
      img.setAttribute('role', 'button');
      img.addEventListener('click', function(e) {
        e.stopPropagation();
        openChatLightbox(mediaUrl, img.alt);
      });
      img.addEventListener('keydown', function(e) {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          openChatLightbox(mediaUrl, img.alt);
        }
      });
      bubble.appendChild(img);
    }
    if (comment.body) {
      var text = document.createElement('span');
      text.textContent = comment.body;
      bubble.appendChild(text);
    }
    return bubble;
  };

  GmChat.prototype.renderCommentRow = function(comment, byId) {
    var self = this;
    var username = this.getCommentDisplayName(comment);
    var user = getCurrentUser();
    var isMine = user && comment.user_id === user.id;

    var msg = document.createElement('div');
    msg.className = this.cls('msg') + ' ' + (isMine ? 'mine' : 'theirs');
    msg.id = 'gm-chat-msg-' + comment.id;

    var userEl = document.createElement('span');
    userEl.className = this.cls('username');
    userEl.textContent = username;
    msg.appendChild(userEl);

    if (comment.parent_id && byId[comment.parent_id]) {
      var parentUser = byId[comment.parent_id].profiles && byId[comment.parent_id].profiles.username
        ? byId[comment.parent_id].profiles.username
        : 'user';
      var replyTo = document.createElement('button');
      replyTo.type = 'button';
      replyTo.className = 'gm-chat-reply-to';
      replyTo.textContent = 'replied to @' + parentUser;
      replyTo.addEventListener('click', function(e) {
        e.preventDefault();
        self.scrollToComment(comment.parent_id);
      });
      msg.appendChild(replyTo);
    }

    msg.appendChild(this.buildCommentBubble(comment));

    var meta = document.createElement('div');
    meta.className = 'gm-chat-meta';

    var timeEl = document.createElement('span');
    timeEl.className = 'gm-chat-time';
    timeEl.textContent = timeAgo(comment.created_at);
    meta.appendChild(timeEl);

    if (user) {
      var replyBtn = document.createElement('button');
      replyBtn.type = 'button';
      replyBtn.className = 'gm-chat-reply-btn';
      replyBtn.textContent = 'reply';
      replyBtn.addEventListener('click', function(e) {
        e.preventDefault();
        self.startReply(comment);
      });
      meta.appendChild(replyBtn);
    }

    if (!isMine) {
      var likeBtn = document.createElement('button');
      likeBtn.className = 'gm-chat-like';
      likeBtn.type = 'button';
      likeBtn.setAttribute('data-id', comment.id);
      likeBtn.setAttribute('aria-label', 'Like message');
      var likeIcon = document.createElement('span');
      likeIcon.className = 'gm-chat-like-icon';
      likeIcon.innerHTML = this.getHeartIconMarkup(false);
      var likeCount = document.createElement('span');
      likeCount.className = 'gm-chat-like-count';
      likeCount.textContent = '0';
      likeBtn.appendChild(likeIcon);
      likeBtn.appendChild(likeCount);
      this.paintLikeButton(likeBtn, comment.id);
      meta.appendChild(likeBtn);
    }

    msg.appendChild(meta);
    return msg;
  };

  GmChat.prototype.renderComments = function(comments, options) {
    options = options || {};
    var preserveScroll = !!options.preserveScroll;
    var prevScrollTop = preserveScroll && this.feed ? this.feed.scrollTop : 0;

    this.allComments = Array.isArray(comments) ? comments : [];
    if (!this.messagesEl) return;

    if (!this.allComments.length) {
      if (this.emptyEl) this.emptyEl.hidden = false;
      this.messagesEl.innerHTML = '';
      this.notifyRendered({ forceScroll: !preserveScroll, scrollToBottom: preserveScroll ? false : undefined });
      return;
    }

    if (this.emptyEl) this.emptyEl.hidden = true;
    this.messagesEl.innerHTML = '';

    var byId = this.getCommentByIdMap(this.allComments);
    var sorted = this.allComments.slice().sort(function(a, b) {
      return new Date(a.created_at) - new Date(b.created_at);
    });

    var self = this;
    sorted.forEach(function(comment) {
      self.messagesEl.appendChild(self.renderCommentRow(comment, byId));
    });

    this.messagesEl.querySelectorAll('.gm-chat-like').forEach(function(btn) {
      btn.addEventListener('click', function() {
        if (!getCurrentUser()) return;
        self.toggleCommentLike(btn.getAttribute('data-id'), btn);
      });
    });

    if (preserveScroll && this.feed) {
      this.notifyRendered({ scrollToBottom: false });
      this.feed.scrollTop = prevScrollTop;
      return;
    }

    if (!this.didInitialRender) {
      this.didInitialRender = true;
      this.notifyRendered({ forceScroll: true });
      return;
    }

    this.notifyRendered({ forceScroll: !!options.forceScroll });
  };

  GmChat.prototype.scrollMessageInFeed = function(commentId, options) {
    options = options || {};
    if (!commentId) return;
    var el = document.getElementById('gm-chat-msg-' + commentId);
    if (!el) return;

    if (this.feed && this.feed.contains(el)) {
      var feed = this.feed;
      var feedRect = feed.getBoundingClientRect();
      var elRect = el.getBoundingClientRect();
      var inView = elRect.top >= feedRect.top && elRect.bottom <= feedRect.bottom;

      if (!inView) {
        var elOffsetInFeed = elRect.top - feedRect.top + feed.scrollTop;
        var targetScroll = elOffsetInFeed - (feed.clientHeight / 2) + (elRect.height / 2);
        targetScroll = Math.max(0, Math.min(targetScroll, feed.scrollHeight - feed.clientHeight));
        if (options.smooth && feed.scrollTo) {
          feed.scrollTo({ top: targetScroll, behavior: 'smooth' });
        } else {
          feed.scrollTop = targetScroll;
        }
      }
    } else {
      el.scrollIntoView({ block: 'center', behavior: options.smooth ? 'smooth' : 'auto' });
    }

    if (options.highlight !== false) {
      this.flashCommentHighlight(commentId);
    }
  };

  GmChat.prototype.scrollToComment = function(commentId) {
    this.scrollMessageInFeed(commentId, { smooth: true });
  };

  GmChat.prototype.flashCommentHighlight = function(commentId) {
    var el = document.getElementById('gm-chat-msg-' + commentId);
    if (!el) return;
    var bubble = el.querySelector('.' + this.cls('bubble'));
    if (!bubble) return;
    bubble.classList.remove('gm-chat-msg-highlight');
    void bubble.offsetWidth;
    bubble.classList.add('gm-chat-msg-highlight');
    window.setTimeout(function() {
      bubble.classList.remove('gm-chat-msg-highlight');
    }, 1000);
  };

  GmChat.prototype.getSafariBarClearance = function() {
    return 72;
  };

  GmChat.prototype.getMobileComposerPadding = function() {
    return 160;
  };

  GmChat.prototype.getVisibleBottom = function() {
    var vv = window.visualViewport;
    var clearance = this.getMobileComposerPadding();
    if (!vv) return window.innerHeight - clearance;
    return vv.offsetTop + vv.height - clearance;
  };

  GmChat.prototype.applyComposerClearance = function() {
    if (this.isPanelFullscreen()) return;
    var composer = this.composerEl;
    if (!composer || composer.hidden) return;

    var bar = composer.querySelector('.gm-chat-bar') || composer;
    var targetBottom = this.getVisibleBottom();
    var barRect = bar.getBoundingClientRect();
    var overflow = barRect.bottom - targetBottom;

    if (overflow <= 0) return;
    window.scrollBy({ top: overflow, left: 0, behavior: 'auto' });
  };

  GmChat.prototype.syncFullscreenPanelLayout = function() {
    if (!this.isPanelFullscreen() || !isMobileChatViewport()) return;

    var inputFocused = this.inputEl && document.activeElement === this.inputEl;
    if (!inputFocused) {
      this.root.style.removeProperty('bottom');
      return;
    }

    var vv = window.visualViewport;
    if (!vv) return;

    var clearance = this.getSafariBarClearance();
    var keyboardGap = Math.max(0, Math.round(window.innerHeight - vv.offsetTop - vv.height));
    var bottom = Math.max(keyboardGap + clearance, clearance);
    this.root.style.bottom = bottom + 'px';

    var composer = this.composerEl;
    if (!composer || composer.hidden) return;
    var bar = composer.querySelector('.gm-chat-bar') || composer;
    var barRect = bar.getBoundingClientRect();
    var targetBottom = vv.offsetTop + vv.height - clearance;
    var overflow = barRect.bottom - targetBottom;
    if (overflow > 0) {
      bottom = (parseFloat(this.root.style.bottom) || bottom) + overflow;
      this.root.style.bottom = bottom + 'px';
    }
  };

  GmChat.prototype.clearFullscreenPanelLayout = function() {
    this.root.style.removeProperty('bottom');
  };

  GmChat.prototype.isPanelFullscreen = function() {
    return this.root.classList.contains('is-fullscreen');
  };

  GmChat.prototype.getReplyScrollAnchor = function() {
    if (this.style !== 'community' || this.isPanelFullscreen()) return null;
    return document.querySelector('.gm-community-gallery .gm-community-panel-header')
      || document.querySelector('.gm-community-gallery');
  };

  GmChat.prototype.ensureMobileViewportForInput = function() {
    if (!isMobileChatViewport()) return;
    var meta = document.querySelector('meta[name="viewport"]');
    if (!meta) return;
    if (!meta.dataset.gmOriginalViewport) {
      meta.dataset.gmOriginalViewport = meta.getAttribute('content') || 'width=device-width, initial-scale=1';
    }
    var base = meta.dataset.gmOriginalViewport;
    if (base.indexOf('interactive-widget') === -1) {
      meta.setAttribute('content', base + ', interactive-widget=resizes-content');
    }
  };

  GmChat.prototype.scrollPageToVisibleBottom = function(el) {
    if (!el) return;
    var viewBottom = this.getVisibleBottom();
    var rect = el.getBoundingClientRect();
    var overflow = rect.bottom - viewBottom;
    if (overflow <= 0) return;
    var top = (window.pageYOffset || document.documentElement.scrollTop || 0) + overflow;
    window.scrollTo({ top: top, left: 0, behavior: 'auto' });
  };

  GmChat.prototype.getKeyboardInset = function() {
    var vv = window.visualViewport;
    if (!vv) return 0;
    return Math.max(0, Math.round(window.innerHeight - vv.height - vv.offsetTop));
  };

  GmChat.prototype.setChatKeyboardOpen = function(open) {
    this.chatKeyboardOpen = open;
    document.body.classList.toggle('gm-chat-keyboard-open', open);
    if (!open) {
      document.documentElement.style.removeProperty('--gm-chat-keyboard-inset');
      this.clearFullscreenPanelLayout();
      return;
    }
    if (!this.isPanelFullscreen()) {
      var inset = this.getKeyboardInset() + this.getMobileComposerPadding();
      document.documentElement.style.setProperty('--gm-chat-keyboard-inset', inset + 'px');
    }
  };

  GmChat.prototype.scrollComposerAboveKeyboardInPanel = function() {
    if (this.replyingTo && this.replyingTo.commentId) {
      this.scrollMessageInFeed(this.replyingTo.commentId, { smooth: false, highlight: false });
    }
    this.syncFullscreenPanelLayout();
    var self = this;
    window.requestAnimationFrame(function() {
      self.syncFullscreenPanelLayout();
    });
  };

  GmChat.prototype.scrollComposerAboveKeyboard = function() {
    var composer = this.composerEl;
    if (!composer || composer.hidden) return;

    if (this.isPanelFullscreen()) {
      this.scrollComposerAboveKeyboardInPanel();
      return;
    }

    var bar = composer.querySelector('.gm-chat-bar') || composer;
    var anchor = this.getReplyScrollAnchor();

    if (anchor) {
      anchor.scrollIntoView({ block: 'end', behavior: 'auto' });
    } else {
      bar.scrollIntoView({ block: 'end', behavior: 'auto' });
    }

    this.scrollPageToVisibleBottom(bar);

    if (anchor) {
      this.scrollPageToVisibleBottom(anchor);
    }

    this.applyComposerClearance();
  };

  GmChat.prototype.syncComposerAboveKeyboard = function() {
    if (!isMobileChatViewport()) {
      this.ensureComposerVisible();
      return;
    }

    var inputFocused = this.inputEl && document.activeElement === this.inputEl;
    var inset = this.getKeyboardInset();

    if (inputFocused) {
      this.ensureMobileViewportForInput();
      this.setChatKeyboardOpen(true);
      if (!this.isPanelFullscreen()) {
        document.documentElement.style.setProperty(
          '--gm-chat-keyboard-inset',
          Math.max(this.getKeyboardInset() + this.getMobileComposerPadding(), 0) + 'px'
        );
      }
      this.scrollComposerAboveKeyboard();
      return;
    }

    if (this.chatKeyboardOpen && inset < 8) {
      this.setChatKeyboardOpen(false);
    } else if (this.chatKeyboardOpen && this.isPanelFullscreen()) {
      this.syncFullscreenPanelLayout();
    } else if (this.chatKeyboardOpen && !this.isPanelFullscreen()) {
      document.documentElement.style.setProperty(
        '--gm-chat-keyboard-inset',
        (inset + this.getMobileComposerPadding()) + 'px'
      );
    }
  };

  GmChat.prototype.bindKeyboardListeners = function() {
    if (this.keyboardListenersBound || !window.visualViewport) return;
    this.keyboardListenersBound = true;
    var self = this;
    window.visualViewport.addEventListener('resize', function() {
      self.syncComposerAboveKeyboard();
    });
    window.visualViewport.addEventListener('scroll', function() {
      self.syncComposerAboveKeyboard();
    });
  };

  GmChat.prototype.scheduleComposerAboveKeyboard = function() {
    var self = this;
    this.syncComposerAboveKeyboard();
    window.requestAnimationFrame(function() {
      self.syncComposerAboveKeyboard();
    });
    [80, 180, 320, 520, 800, 1100, 1400, 1800].forEach(function(delay) {
      window.setTimeout(function() {
        self.syncComposerAboveKeyboard();
      }, delay);
    });
  };

  GmChat.prototype.onPanelFullscreenChange = function() {
    if (!isMobileChatViewport()) return;
    if (!this.isPanelFullscreen()) {
      this.clearFullscreenPanelLayout();
      return;
    }
    if (this.inputEl && document.activeElement === this.inputEl) {
      this.scheduleComposerAboveKeyboard();
      return;
    }
    if (this.replyingTo) {
      this.scheduleComposerAboveKeyboard();
    }
  };

  GmChat.prototype.onComposerFocus = function() {
    if (!isMobileChatViewport()) {
      this.ensureComposerVisible();
      return;
    }
    this.ensureMobileViewportForInput();
    this.bindKeyboardListeners();
    this.scheduleComposerAboveKeyboard();
  };

  GmChat.prototype.onComposerBlur = function() {
    if (!isMobileChatViewport()) return;
    var self = this;
    window.setTimeout(function() {
      if (self.inputEl && document.activeElement === self.inputEl) return;
      if (self.sendBtn && document.activeElement === self.sendBtn) return;
      self.setChatKeyboardOpen(false);
    }, 120);
  };

  GmChat.prototype.ensureComposerVisible = function() {
    var composer = this.composerEl;
    if (!composer || composer.hidden) return;

    var vv = window.visualViewport;
    var viewTop = vv ? vv.offsetTop : 0;
    var viewBottom = vv ? vv.offsetTop + vv.height : window.innerHeight;
    var padding = 20;
    var rect = composer.getBoundingClientRect();

    if (rect.bottom > viewBottom - padding || rect.top < viewTop + padding) {
      composer.scrollIntoView({ block: 'end', behavior: 'auto' });
    }
  };

  GmChat.prototype.updateReplyBanner = function() {
    if (!this.replyBanner || !this.replyBannerText) return;
    if (!this.replyingTo) {
      this.replyBanner.hidden = true;
      this.replyBannerText.textContent = '';
      return;
    }
    this.replyBannerText.textContent = 'replying to @' + this.replyingTo.username;
    this.replyBanner.hidden = false;
  };

  GmChat.prototype.clearReplyingTo = function() {
    this.replyingTo = null;
    this.updateReplyBanner();
  };

  GmChat.prototype.startReply = function(comment) {
    if (!getCurrentUser() || !comment || !comment.id) return;
    var username = comment.profiles && comment.profiles.username ? comment.profiles.username : 'anonymous';
    this.replyingTo = { commentId: comment.id, username: username };
    this.updateReplyBanner();
    this.flashCommentHighlight(comment.id);
    if (this.inputEl && typeof this.inputEl.focus === 'function') {
      try {
        this.inputEl.focus({ preventScroll: true });
      } catch (e) {
        this.inputEl.focus();
      }
    }
    this.onComposerFocus();
  };

  GmChat.prototype.setChatComposerBusy = function(busy) {
    this.chatMediaUploading = busy;
    if (this.sendBtn) this.sendBtn.disabled = busy;
    if (this.attachBtn) this.attachBtn.disabled = busy;
    if (this.inputEl) this.inputEl.disabled = busy;
  };

  GmChat.prototype.clearPendingChatMedia = function() {
    if (this.pendingChatMedia && this.pendingChatMedia.previewUrl) {
      URL.revokeObjectURL(this.pendingChatMedia.previewUrl);
    }
    this.pendingChatMedia = null;
    if (this.mediaPreview) this.mediaPreview.hidden = true;
    if (this.mediaInput) this.mediaInput.value = '';
  };

  GmChat.prototype.showPendingChatMedia = function(file) {
    this.clearPendingChatMedia();
    var mediaType = file.type === 'image/gif' ? 'gif' : 'image';
    var previewUrl = URL.createObjectURL(file);
    this.pendingChatMedia = { file: file, previewUrl: previewUrl, mediaType: mediaType };
    if (this.mediaPreview && this.mediaPreviewImg) {
      this.mediaPreviewImg.src = previewUrl;
      this.mediaPreviewImg.alt = mediaType === 'gif' ? 'gif preview' : 'photo preview';
      this.mediaPreview.hidden = false;
    }
  };

  GmChat.prototype.handleChatMediaSelected = function(event) {
    var file = event.target.files && event.target.files[0];
    if (!file) return;
    if (!CHAT_MEDIA_ALLOWED_TYPES[file.type]) {
      event.target.value = '';
      return;
    }
    if (file.size > CHAT_MEDIA_MAX_BYTES) {
      event.target.value = '';
      return;
    }
    this.showPendingChatMedia(file);
  };

  GmChat.prototype.uploadChatMedia = async function(file, token, userId) {
    var ext = CHAT_MEDIA_ALLOWED_TYPES[file.type] || 'bin';
    var path = userId + '/' + Date.now() + '-' + Math.random().toString(36).slice(2, 10) + '.' + ext;
    var uploadRes = await fetch(SUPABASE_URL + '/storage/v1/object/' + CHAT_MEDIA_BUCKET + '/' + path, {
      method: 'POST',
      headers: {
        Authorization: 'Bearer ' + token,
        apikey: SUPABASE_ANON_KEY,
        'Content-Type': file.type,
        'Cache-Control': '3600',
        'x-upsert': 'false'
      },
      body: file
    });
    if (!uploadRes.ok) throw new Error('upload failed');
    return SUPABASE_URL + '/storage/v1/object/public/' + CHAT_MEDIA_BUCKET + '/' + path;
  };

  GmChat.prototype.fetchCommentLikesMeta = async function(commentIds) {
    var counts = {};
    var userLiked = {};
    (commentIds || []).forEach(function(id) {
      counts[id] = 0;
      userLiked[id] = false;
    });
    if (!commentIds || !commentIds.length) return { counts: counts, userLiked: userLiked };

    var token = await getValidAccessToken();
    var authHeader = token ? ('Bearer ' + token) : ('Bearer ' + SUPABASE_ANON_KEY);
    var filter = 'comment_id=in.(' + commentIds.join(',') + ')';
    var res = await fetch(SUPABASE_URL + '/rest/v1/comment_likes?' + filter + '&select=comment_id,user_id', {
      headers: { apikey: SUPABASE_ANON_KEY, Authorization: authHeader }
    });
    var rows = [];
    try { rows = await res.json(); } catch (e) { rows = []; }
    if (!Array.isArray(rows)) return { counts: counts, userLiked: userLiked };

    var user = getCurrentUser();
    rows.forEach(function(row) {
      if (!row || !row.comment_id) return;
      counts[row.comment_id] = (counts[row.comment_id] || 0) + 1;
      if (user && row.user_id === user.id) userLiked[row.comment_id] = true;
    });
    return { counts: counts, userLiked: userLiked };
  };

  GmChat.prototype.refreshCommentLikeCounts = async function() {
    if (!this.allComments.length) return;
    var ids = this.allComments.map(function(c) { return c.id; }).filter(Boolean);
    var meta = await this.fetchCommentLikesMeta(ids);
    this.commentLikeCounts = meta.counts;
    this.commentUserLiked = meta.userLiked;
    var self = this;
    if (this.messagesEl) {
      this.messagesEl.querySelectorAll('.gm-chat-like').forEach(function(btn) {
        self.paintLikeButton(btn, btn.getAttribute('data-id'));
      });
    }
  };

  GmChat.prototype.loadComments = async function(silent, options) {
    options = options || {};
    try {
      var url = SUPABASE_URL + '/rest/v1/comments'
        + '?context_type=eq.' + encodeURIComponent(this.contextType)
        + '&context_id=eq.' + encodeURIComponent(this.contextId)
        + '&is_deleted=eq.false&order=created_at.asc'
        + '&select=*,profiles!comments_user_id_fkey(username)';
      var res = await fetch(url, {
        headers: { apikey: SUPABASE_ANON_KEY, Authorization: 'Bearer ' + SUPABASE_ANON_KEY }
      });
      var data = await res.json();
      if (!Array.isArray(data)) {
        if (!silent) this.renderComments([]);
        return;
      }
      var ids = data.map(function(c) { return c.id; }).filter(Boolean);
      var meta = await this.fetchCommentLikesMeta(ids);
      this.commentLikeCounts = meta.counts;
      this.commentUserLiked = meta.userLiked;
      this.renderComments(data, {
        preserveScroll: !!silent && !options.forceScroll && this.didInitialRender,
        forceScroll: !!options.forceScroll
      });
    } catch (e) {
      if (!silent) console.error('gm-chat load error', e);
    }
  };

  GmChat.prototype.isAuthErrorResponse = function(res, data) {
    if (res.status === 401 || res.status === 403) return true;
    var msg = getErrorText(data);
    return /expired|invalid.*token|access token|jwt|revoked|malformed|not authenticated|invalid for other reasons/i.test(msg);
  };

  GmChat.prototype.toggleCommentLike = async function(commentId, btn) {
    var user = getCurrentUser();
    if (!commentId || !btn || !user) return;
    var token = await getValidAccessToken();
    if (!token) return;

    var isLiked = !!this.commentUserLiked[commentId];
    if (isLiked) {
      var delRes = await fetch(
        SUPABASE_URL + '/rest/v1/comment_likes?comment_id=eq.' + encodeURIComponent(commentId) + '&user_id=eq.' + encodeURIComponent(user.id),
        { method: 'DELETE', headers: { apikey: SUPABASE_ANON_KEY, Authorization: 'Bearer ' + token } }
      );
      if (!delRes.ok) return;
      this.commentUserLiked[commentId] = false;
      this.commentLikeCounts[commentId] = Math.max(0, (this.commentLikeCounts[commentId] || 1) - 1);
      this.paintLikeButton(btn, commentId);
      this.refreshCommentLikeCounts();
      return;
    }

    var postRes = await fetch(SUPABASE_URL + '/rest/v1/comment_likes', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        apikey: SUPABASE_ANON_KEY,
        Authorization: 'Bearer ' + token,
        Prefer: 'return=minimal'
      },
      body: JSON.stringify({ comment_id: commentId, user_id: user.id })
    });
    if (postRes.ok || postRes.status === 409) {
      this.commentUserLiked[commentId] = true;
      if (postRes.ok) this.commentLikeCounts[commentId] = (this.commentLikeCounts[commentId] || 0) + 1;
      this.paintLikeButton(btn, commentId);
      this.refreshCommentLikeCounts();
    }
  };

  GmChat.prototype.postComment = async function() {
    if (this.chatMediaUploading) return;
    var user = getCurrentUser();
    if (!user || !this.inputEl) return;

    var body = this.inputEl.value.trim();
    var hasMedia = !!this.pendingChatMedia;
    if (!body && !hasMedia) return;

    var token = await getValidAccessToken();
    if (!token) return;

    var mediaUrl = null;
    var mediaType = null;
    if (hasMedia) {
      this.setChatComposerBusy(true);
      try {
        mediaUrl = await this.uploadChatMedia(this.pendingChatMedia.file, token, user.id);
        mediaType = this.pendingChatMedia.mediaType;
      } catch (e) {
        console.error('gm-chat media upload', e);
        this.setChatComposerBusy(false);
        return;
      }
      this.setChatComposerBusy(false);
    }

    var payload = {
      user_id: user.id,
      context_type: this.contextType,
      context_id: this.contextId,
      body: body || ''
    };
    if (this.replyingTo && this.replyingTo.commentId) payload.parent_id = this.replyingTo.commentId;
    if (mediaUrl) {
      payload.media_url = mediaUrl;
      payload.media_type = mediaType;
    }

    var res = await fetch(SUPABASE_URL + '/rest/v1/comments', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        apikey: SUPABASE_ANON_KEY,
        Authorization: 'Bearer ' + token,
        Prefer: 'return=minimal'
      },
      body: JSON.stringify(payload)
    });

    if (!res.ok) {
      var data = null;
      try { data = await res.json(); } catch (e) { /* empty */ }
      console.error('gm-chat post error', getErrorText(data) || res.status);
      return;
    }

    this.inputEl.value = '';
    this.clearPendingChatMedia();
    this.clearReplyingTo();
    var self = this;
    window.setTimeout(function() { self.loadComments(false, { forceScroll: true }); }, 400);
  };

  function initAll() {
    document.querySelectorAll('[data-gm-chat]').forEach(function(root) {
      if (root.dataset.gmChatReady === 'true') return;
      root.dataset.gmChatReady = 'true';
      root._gmChatInstance = new GmChat(root);
    });
  }

  function syncAllAuthUi() {
    document.querySelectorAll('[data-gm-chat]').forEach(function(root) {
      if (root._gmChatInstance && typeof root._gmChatInstance.syncAuthUi === 'function') {
        root._gmChatInstance.syncAuthUi();
      }
    });
  }

  window.__gmChat = {
    initAll: initAll,
    syncAllAuthUi: syncAllAuthUi,
    openLightbox: openChatLightbox,
    closeLightbox: closeChatLightbox
  };

  document.addEventListener('DOMContentLoaded', function() {
    initAll();
    window.setTimeout(syncAllAuthUi, 400);
    window.setTimeout(syncAllAuthUi, 1200);
  });
})();
